import { EMessageContentType } from '../models';

export const getReactionContentText = (
  isMine: boolean,
  contentType: EMessageContentType.Pick | EMessageContentType.List | EMessageContentType.Thought
): string => `${isMine ? 'You reacted to their' : 'Reacted to your'} ${contentType.toLocaleLowerCase()}`;
